import * as React from "react";
import { BulkExportProvider, SubscriptionProvider } from "./providers";
import { SnackBarBulkExportBASF } from "./components/SnackBarBulkExportBASF";
import Layout from "../../layouts/Layout";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";
import { BulkExportLayout } from "./components/BulkExportLayout";
import { BulkExportToolbar } from "./components/BulkExportToolbar";
import { BulkExportBox } from "./components/BulkExportBox";
import { DataSourceControl } from "./components/DataSourceControl";
import { BulkExportStepper } from "./components/BulkExportStepper";

export const Root: React.FC = (props) => {
  return (
    <>
      <Layout>
        <Header />
        <BulkExportProvider>
          <BulkExportLayout>
            <BulkExportToolbar />
            <BulkExportBox>
              <DataSourceControl />
              <SubscriptionProvider>
                <BulkExportStepper />
              </SubscriptionProvider>
            </BulkExportBox>
          </BulkExportLayout>
        </BulkExportProvider>
        <Footer />
      </Layout>
      <SnackBarBulkExportBASF />
    </>
  );
};
